import { render, staticRenderFns } from "./Tarjetas.vue?vue&type=template&id=240aaa36&scoped=true"
import script from "./Tarjetas.vue?vue&type=script&lang=js"
export * from "./Tarjetas.vue?vue&type=script&lang=js"
import style0 from "./Tarjetas.vue?vue&type=style&index=0&id=240aaa36&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240aaa36",
  null
  
)

export default component.exports